module.exports = __webpack_public_path__ + "static/media/CV_Charlotte_Isambert_en.9bbf4f8f.pdf";